// WHOLESALE, WHOLESALE_BUKHARA, WHOLESALE_SAMARKAND, RETAIL
const priceTypes = [
  {
    en: "WHOLESALE",
    uz: "Optom (Toshkent)",
  },
  {
    en: "WHOLESALE_BUKHARA",
    uz: "Optom (Buxoro)",
  },
  {
    en: "WHOLESALE_SAMARKAND",
    uz: "Optom (Samarqand)",
  },
  {
    en: "RETAIL",
    uz: "Donalik savdo",
  },
];

export default priceTypes;
